module.exports = __webpack_public_path__ + "9b800c51b8de244cbef5ef6d811a3a5d.svg";